// biome-ignore lint/style/noRestrictedImports: encapsulation
import { floor as floor_ } from "remeda";

import { unpurry } from "./_unpurry";

export const floor = unpurry(floor_, 2);
